import supabase from './supabaseClient';

class EdgeFunctionClient {
  static async call(functionName, payload = {}) {
    try {
      const { data, error } = await supabase.functions.invoke(functionName, {
        body: payload
      });

      if (error) {
        // Handle Supabase function invocation errors
        throw new Error(`Error calling ${functionName}: ${error.message}`);
      }

      // Check if the response itself contains an error field
      if (data && data.error) {
        throw new Error(data.error);
      }

      return data;
    } catch (error) {
      // Create a custom error with status code if available
      const enhancedError = new Error(error.message);
      enhancedError.status = error.status || 500;
      throw enhancedError;
    }
  }
}

export default EdgeFunctionClient;
